import type { ImageAdapterResolver } from "./ImageAdapterResolver";
import type { ImageAdapter } from "./ImageAdapter";
import type { ImageAdapterFactoriesPool } from "./ImageAdapterFactoriesPool";
import type { ImageAdapterFactory } from "./ImageAdapterFactory";

/**
 * Base implementation of ImageAdapterResolver interface.
 */
export class BaseImageAdapterResolver implements ImageAdapterResolver {
  /**
   * BaseImageAdapterResolver constructor.
   *
   * @param factoriesPool
   */
  constructor(private readonly factoriesPool: ImageAdapterFactoriesPool) {}

  /**
   * @inheritDoc
   */
  resolve<ResourceType>(resource: ResourceType): ImageAdapter<ResourceType> {
    const factories = this.factoriesPool.items();
    const factory = factories.find((f) => f.match(resource));
    if (factory) {
      return (factory as ImageAdapterFactory<ResourceType>).create(resource);
    }
    const resourceName = Object.prototype.toString.call(resource).slice(8, -1);
    throw new TypeError(
      `No matching image adapter factory for resource of type ${resourceName}`
    );
  }
}
